<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
    
  },
  mounted() {
  }
}
</script>

<style>
#app {
  width:100%;
  height:100%;

}
</style>
